import { Box, Typography } from "@mui/material"
import { CustomeIconButton } from "../customeIconButton"
import { icons } from "../../utils/icons"
import { useStyles } from "./styles"
import { ScrollContainer } from "../scrollContainer"

export const ListTooltipDetail = ({ list }: { list: string[] }) => {
    const styles = useStyles()
    return (
        <Box sx={styles.container}>
            <Typography variant="text_grey" fontWeight='500'>{list[0]  || 'N/A'}</Typography>

            {list?.length > 1 && (
                <CustomeIconButton
                    iconButtonProps={{ disableRipple: true, sx: styles.icon }}
                    title={<ScrollContainer sx={styles.list}>{list.map((item, index) => <Typography key={index} variant="text_grey" color='white'>&#9679; {item}</Typography>)}</ScrollContainer>}
                    icon={icons('add-outline')}
                />
            )}
        </Box>
    )
}